<div [ngClass]="{ 'ap-opacity-6 pe-none': !isUpsertFormSecurityEnabled() }">
  <div class="ap-p-spacing-6">
    <div class="ap-typography-heading-m">
      {{ securityTitle }}
    </div>
  </div>

  <div class="ap-ml-spacing-5 ap-mr-spacing-5 ap-mb-spacing-4">
    <gstar-entity-types-combobox
      [required]="true"
      [value]="selectedEntityType()"
      [onlyActives]="true"
      [onlyNonDefaults]="true"
      [filterByJurisdiction]="false"
      [disabled]="!!formValue()"
      (selectEntityType)="selectEntityType($event)"
      (clearTargetEntityTypeValue)="clearEntityType()" />

    <gstar-investment-jurisdiction-combobox
      [required]="true"
      [value]="selectedInvestmentJurisdiction()"
      [disabled]="!!formValue()"
      (selectInvestmentJurisdiction)="selectInvestmentJurisdiction($event)"
      (clearInvestmentJurisdiction)="clearInvestmentJurisdiction()" />

    <gstar-security-types-combobox
      [required]="true"
      [value]="selectedSecurityType()"
      [disabled]="!!formValue()"
      [allowedSecurityTypeNames]="securityTypeNameFilters"
      (selectSecurityType)="selectSecurityType($event)"
      (clearSecurityType)="clearSecurityType()" />

    <div class="d-flex gap-3 justify-content-end">
      <ap-button
        type="button"
        btnType="secondary"
        [disabled]="!!formValue()"
        [label]="'shared.cancel' | translate"
        (onClick)="cancel()" />
      <ap-button
        btnType="primary"
        [disabled]="!isContinueEnabled()"
        [label]="'shared.continue' | translate"
        (onClick)="continue()" />
    </div>

    <div [class.d-none]="hasNoQuestions()">
      <gstar-rules-engine-view
        #rulesEngineForm
        [formValue]="formValue()"
        [transactionType]="state.transactionType"
        [securityId]="state.securityId"
        (dynamicFormCompleted)="setFormCompleted($event)" />

      @if (rulesEngineForm.inProgress) {
        <div class="d-flex gap-3 justify-content-end ap-mt-spacing-5">
          <ap-button
            type="button"
            btnType="secondary"
            [label]="'shared.cancel' | translate"
            (onClick)="resetEvaluation()" />
          <ap-button
            btnType="primary"
            [disabled]="!securityRequest()"
            [label]="'shared.save' | translate"
            (onClick)="createSecurity()" />
        </div>
      }
    </div>
  </div>
</div>
